import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { CircularProgress } from '@mui/material';
import { CSSTransition } from 'react-transition-group';

import withPortal from '../withPortal';
import transitionsConfig from './transitionsConfig';
import {
  Overlay,
  StyledTypography,
} from './styles';

const LoadingOverlay = ({
  isLoading,
  loadingText,
  spinnerProps,
}) => {
  const overlayRef = useRef(null);

  return (
    <CSSTransition
      timeout={transitionsConfig.delay}
      classNames={transitionsConfig.classNames.overlay}
      in={isLoading}
      unmountOnExit
      nodeRef={overlayRef}
    >
      <Overlay ref={overlayRef}>
        <CircularProgress {...spinnerProps} />
        {!!loadingText && <StyledTypography>{loadingText}</StyledTypography>}
      </Overlay>
    </CSSTransition>
  );
};

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  spinnerProps: PropTypes.object,
};

LoadingOverlay.defaultProps = {
  isLoading: false,
  loadingText: '',
  spinnerProps: {
    size: 25,
  },
};

export default compose(
  withPortal('loadingOverlay'),
)(LoadingOverlay);
